import React from 'react';
import DocumentMeta from 'react-document-meta';
import '../../styles/app.css';
import '../../styles/metafans.scss';

import Vip from '../sections/Home/Vip.jsx';
import Genesis from '../sections/Home/Genesis.jsx';
import How from '../sections/Home/How.jsx';
import Mint from '../sections/Home/Mint.jsx';
import Meet from '../sections/Home/Meet.jsx';
import CountdownTimer from '../sections/Home/Countdown.jsx';
import Newbs from '../sections/Home/Newbs.jsx';
import Signup from '../sections/Home/Signup.jsx';
import Faqs from '../sections/Home/FAQs.jsx';

function Home() {
  const meta = {
    title: 'MetaFans NFT Collection',
    description:
      'Learn about the ultimate sports-focused NFT project with the best utility!',
  };

  return (
    <>
      <DocumentMeta {...meta}></DocumentMeta>
      <div className="theme-dk-blue">
        {/* <CountdownTimer /> */}
        <Vip />
        <Genesis />
        <Mint />
        <Meet />
        <Faqs />
        <Signup />
      </div>
    </>
  );
}

export default Home;
